import { DATE_FORMAT, SHORT_DATE_FORMAT } from "@/components/shared/util";
import { parseServerTime } from "@/filters/DateAndTime";
import { RiskFactor } from "@/store/types";
import _ from "lodash";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import HandoffShared from "./HandoffShared";

@Component({})
export default class HandoffPatientInfo extends mixins(HandoffShared) {
  get tableData() {
    const rows: { label: string; value: string }[] = [];

    function add(label: string, value: string) {
      rows.push({
        label,
        value
      });
    }
    add("Room", this.current.census.displayRoom);

    add("Age", this.current.census.age.toString());
    const procedure = _.get(this.current, "body.atoms.procedureName.legend");
    if (procedure) {
      add("Procedure", procedure);
    }
    add("Gender", this.current.census.gender);
    const asa = _.get(this.current, "body.atoms.asa.legend");
    if (asa) {
      add("ASA", asa);
    }
    add("Weight", this.current.body.atoms.weight.value.toFixed(1) + " KG");

    // Add staff
    this.staffRoleAndName.forEach(staff => {
      add(staff.role, staff.userName);
    });

    add("BMI", this.current.body.atoms.bmi.value.toFixed(2));

    add("Surgery Date", parseServerTime(this.opDate).format(DATE_FORMAT));
    if (this.config.popups.PatientHandoff.display.pacu) {
      add(
        "Surgery time",
        this.current.body.atoms.surgeryHours.value.toFixed(1) + " hours"
      );
    }

    add("Admit", this.admit);
    if (
      this.current.body.atoms.generalAnesthesia &&
      this.config.popups.PatientHandoff.display.or
    ) {
      add("Anesthesia", this.current.body.atoms.generalAnesthesia.legend);
    }
    if (
      this.config.popups.PatientHandoff.display.pacu &&
      this.priorGeneralAnesthesia
    ) {
      add("Anesthesia", this.priorGeneralAnesthesia);
    }
    return rows;
  }

  get displayTime() {
    return parseServerTime(this.now).format(SHORT_DATE_FORMAT);
  }

  get diagnosis(): string {
    const priorAdmitDiagnosis = _.get(
      this,
      "current.body.prior.census.admitDiagnosis"
    );
    return this.config.popups.PatientHandoff.display.pacu
      ? priorAdmitDiagnosis
      : this.current.census.admitDiagnosis;
  }

  get opDate(): string {
    const opPriorDate = _.get(this, "current.body.prior.census.opDate");
    return this.config.popups.PatientHandoff.display.pacu
      ? opPriorDate
      : this.current.census.opDate;
  }

  get staff(): { role: string; userName: string }[] {
    const priorStaff = _.get(this, "current.body.prior.census.staff", []);
    return this.config.popups.PatientHandoff.display.pacu
      ? priorStaff
      : this.current.census.staff;
  }

  readonly staffToGet = ["Surgeon", "CRNA", "Resident", "Attending"];
  get staffRoleAndName() {
    let hasSurgen = false;
    const filteredStaff = this.staff.filter(staff => {
      if (!hasSurgen) {
        hasSurgen = staff.role === "Surgeon";
      }
      return this.staffToGet.includes(staff.role);
    });

    if (!hasSurgen) {
      filteredStaff.unshift({ role: "Surgeon", userName: "Unknown" });
    }
    return filteredStaff;
  }

  get otherStaff() {
    return this.staff
      .filter((staff: any) => staff.role !== "Attending")
      .map((staff: any) => staff.userName);
  }

  get admit() {
    if (this.config.popups.PatientHandoff.display.pacu) {
      return this.current.body.atoms.admitStatus.legend;
    }

    const admit = this.vars.riskFactor
      .filter((factor: RiskFactor) => {
        return (
          factor.segment === "admit" &&
          this.current.body.risk.includes(factor.name)
        );
      })
      .map((factor: RiskFactor) => {
        return factor.display;
      });
    return _.get(admit, "[0]", "");
  }

  get priorGeneralAnesthesia(): string | null {
    return _.get(this, "current.body.prior.atoms.generalAnesthesia.legend");
  }
}
